import { render, staticRenderFns } from "./ReservationLimit.vue?vue&type=template&id=23a41ae0&scoped=true&"
import script from "./ReservationLimit.vue?vue&type=script&lang=js&"
export * from "./ReservationLimit.vue?vue&type=script&lang=js&"
import style0 from "./ReservationLimit.vue?vue&type=style&index=0&id=23a41ae0&lang=scss&scoped=true&"
import style1 from "./ReservationLimit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a41ae0",
  null
  
)

export default component.exports